import Layout from "../../../../src/components/Layout";
import EventInList from "../../../../src/components/EventInList";
import * as React from 'react';
export default {
  Layout,
  EventInList,
  React
};